import { apolloClient } from "@/plugins/vue-apollo.js";

const updatePaymentStatus = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/payments/api/mutations/payment_status_change.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/payments/api/queries/payment_query.graphql")
        };
        let allPayments = store.readQuery(query);
        store.writeQuery({
          ...query,
            data: allPayments,
            status: data
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { updatePaymentStatus };
